/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find out how much of a compound to weigh out for a target molar concentration. Enter any three values and leave the one you want to find blank — it solves mass = molarity × volume × molecular weight.`)
};

const es_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Averigua cuánto compuesto pesar para lograr una concentración molar objetivo. Introduce tres valores cualesquiera y deja en blanco el que quieras calcular — resuelve masa = molaridad × volumen × peso molecular.`)
};

const de_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie heraus, wie viel einer Verbindung Sie für eine Zielmolarität einwiegen müssen. Geben Sie drei beliebige Werte ein und lassen Sie das gesuchte Feld leer — es löst Masse = Molarität × Volumen × Molekulargewicht.`)
};

const nl_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken hoeveel van een verbinding je moet afwegen voor een gewenste molaire concentratie. Vul drie waarden in en laat het veld dat je wilt berekenen leeg — de calculator lost massa = molariteit × volume × molecuulgewicht op.`)
};

const fr_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déterminez la quantité de composé à peser pour une concentration molaire cible. Entrez trois valeurs et laissez vide celle que vous souhaitez trouver — il résout masse = molarité × volume × masse moléculaire.`)
};

const it_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri quanto composto pesare per ottenere una concentrazione molare target. Inserisci tre valori qualsiasi e lascia vuoto quello che vuoi trovare — risolve massa = molarità × volume × peso molecolare.`)
};

const pt_br2_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quanto de um composto pesar para atingir uma concentração molar alvo. Informe três valores e deixe em branco o que deseja encontrar — a calculadora resolve massa = molaridade × volume × peso molecular.`)
};

const pt_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quanto composto pesar para obter uma concentração molar pretendida. Introduza quaisquer três valores e deixe em branco o que pretende calcular — resolve massa = molaridade × volume × massa molecular.`)
};

const ja_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標のモル濃度を得るために化合物をどれだけ秤量すればよいか計算します。3つの値を入力し、求めたい項目は空欄のままにしてください — 質量 = モル濃度 × 体積 × 分子量を解きます。`)
};

const zh_massmol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算为达到目标摩尔浓度需要称量多少化合物。输入任意三个数值，将要求解的字段留空——它会求解质量 = 摩尔浓度 × 体积 × 分子量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_intro", locale)
	if (locale === "en") return en_massmol_intro(inputs)
	if (locale === "es") return es_massmol_intro(inputs)
	if (locale === "de") return de_massmol_intro(inputs)
	if (locale === "nl") return nl_massmol_intro(inputs)
	if (locale === "fr") return fr_massmol_intro(inputs)
	if (locale === "it") return it_massmol_intro(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_intro(inputs)
	if (locale === "pt") return pt_massmol_intro(inputs)
	if (locale === "ja") return ja_massmol_intro(inputs)
	return zh_massmol_intro(inputs)
};